import React from 'react';
import testIds from '@smart-tv/e2e/shared/variables';
import { LiveTvChannel } from '@smart-tv/typings/content';
import Typography from '@smart-tv/components/typography';
import useStream from './_hooks/use-stream';
import DisplacedIndicator from './player-controls/player-controls-scrubber/displaced-indicator';
import RecordingLabel from './recording-label';
import styles from './player-information.module.scss';

interface Props {
  channel?: LiveTvChannel;
}

/**
 * The PlayerInformation component renders information about the stream that is currently being played.
 */
export const PlayerInformation: React.FC<Props> = ({ channel }) => {
  const { displayStreamTitles } = useStream();

  return (
    <div className={styles['player-information']}>
      <Typography variant="h1" data-testid={testIds.player.controls.title}>
        {displayStreamTitles?.title}
      </Typography>
      <div
        className={styles['player-information__metadata']}
        data-testid={testIds.player.controls.meta}
      >
        <Typography variant="body" className={styles['player-information__subtitle']}>
          {displayStreamTitles?.subtitle}
        </Typography>
        <RecordingLabel channel={channel} />
        <DisplacedIndicator />
      </div>
    </div>
  );
};

PlayerInformation.displayName = 'PlayerInformation';

export default PlayerInformation;
